import * as React from "react";
const SvgTriangleUp = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path d="m12 5 9 14H3Z" /></svg>;
export default SvgTriangleUp;